import detailStyles from '../ChallengeDetail.module.scss';

export const FragmentsDrawPrizesLevelDescription = () => {
    return (
        <div className={detailStyles.description}>
            <p>
                <div>
                    Чем больше игроков участвует в розыгрыше за серые билеты — тем больше фрагментов разыгрывается среди тех, кто не выиграл сертификат.
                </div>
            </p>
        </div>
    );
}